import { createAsyncThunk } from "@reduxjs/toolkit"
import { del, patch, post, put } from "helpers/api_helper"
import {
  ADD_ITEM_GROUP,
  DELETE_ITEM_GROUP,
  GET_ALL_ITEM_GROUPS,
  GET_ITEM_GROUP_DETAILS,
  GET_ITEM_GROUPS_LIST,
  UPDATE_ITEM_GROUP,
  UPDATE_ITEM_GROUPS_STATUS,
} from "helpers/url_helper"

export const getItemGroups = createAsyncThunk(
  GET_ALL_ITEM_GROUPS,
  async payload => {
    const response = await post(GET_ALL_ITEM_GROUPS, payload)
    return response
  }
)

export const getItemGroupsList = createAsyncThunk(
  GET_ITEM_GROUPS_LIST,
  async payload => {
    const response = await post(GET_ITEM_GROUPS_LIST, payload)
    return response
  }
)

export const updateItemGroupStatus = createAsyncThunk(
  UPDATE_ITEM_GROUPS_STATUS,
  async payload => {
    const response = await patch(UPDATE_ITEM_GROUPS_STATUS, payload)
    return response
  }
)

export const deleteItemGroup = createAsyncThunk(
  DELETE_ITEM_GROUP,
  async payload => {
    const response = await del(DELETE_ITEM_GROUP, payload)
    return response
  }
)

export const addItemGroup = createAsyncThunk(ADD_ITEM_GROUP, async payload => {
  const response = await post(ADD_ITEM_GROUP, payload)
  return response
})

export const getItemGroupDetails = createAsyncThunk(
  GET_ITEM_GROUP_DETAILS,
  async payload => {
    const response = await post(GET_ITEM_GROUP_DETAILS, payload)
    return response
  }
)

export const updateItemGroup = createAsyncThunk(
  UPDATE_ITEM_GROUP,
  async payload => {
    const response = await put(UPDATE_ITEM_GROUP, payload)
    return response
  }
)
